import React from 'react';
import moment from 'moment';
import { WeekDayWrapper, WeekDayButton, ButtonText } from './styles';

const generateWeekDays = (startDate) => {
  const start = moment(startDate).startOf('week');
  const end = moment(startDate).endOf('week');
  const weekDaysObj = [{
    upper: 'Week',
    lower: `${start.format('DD')}-${end.format('DD')}`,
  }];

  let i = 0;
  for (i = 0; i < 7; i += 1) {
    weekDaysObj.push({
      upper: start.format('dd'),
      lower: start.format('DD'),
    });
    start.add(1, 'days');
  }
  return weekDaysObj;
};

const WeekDayPicker = ({
  onChange, startDate, selection, disabled,
}) => (
  <WeekDayWrapper
    onChange={onChange}
    value={parseInt(selection, 0) || 0}
  >
    {
      generateWeekDays(startDate).map((item, i) => (
        <WeekDayButton
          color="clientPrimary"
          borderColor="clientPrimary"
          value={i}
          key={item.upper}
          px={2}
          py={1}
          disabled={disabled}
        >
          <ButtonText
            fontSize={2}
            fontWeight="600"
          >
            {item.upper}
          </ButtonText>
          <ButtonText
            fontSize={2}
            fontWeight="200"
            letterSpacing="-0.5px"
          >
            {item.lower}
          </ButtonText>
        </WeekDayButton>
      ))
    }
  </WeekDayWrapper>
);

export default WeekDayPicker;
